import { render, staticRenderFns } from "./Waves.vue?vue&type=template&id=ae980370&scoped=true&"
import script from "./Waves.vue?vue&type=script&lang=js&"
export * from "./Waves.vue?vue&type=script&lang=js&"
import style0 from "./Waves.vue?vue&type=style&index=0&id=ae980370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae980370",
  null
  
)

export default component.exports